import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CTA_LABEL, site } from '../data/site';
export function HeroSection() {
  return <section id="top" className="court-marks flex bg-brand-main px-4 pb-8 pt-6 text-center sm:pb-10 sm:pt-8" data-id="element-104" data-mp="23v1jv73rngfk">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.55,
      ease: [0.22, 1, 0.36, 1]
    }} className="mx-auto flex w-full max-w-[1120px] flex-col items-center justify-center" data-id="element-105" data-mp="28tmnzhm52k9a">
        <p className="mb-2 text-[10px] font-extrabold tracking-[0.18em] text-brand-teal sm:text-[11px]" data-id="element-106" data-mp="30n53q4k5ag8g">
          READY-TO-USE RESOURCES FOR ELEMENTARY &amp; SECONDARY PE
        </p>
        <h1 className="mx-auto max-w-3xl text-[1.75rem] font-black leading-[1.08] tracking-tight text-brand-blue sm:text-[2.6rem] md:text-[3.2rem]" data-id="element-107" data-mp="2rr5uoel4jqsj">
          Plan a Full Year of PE in{' '}
          <span className="italic text-brand-orange" data-id="element-108" data-mp="3kamce25d8ey1">
            Minutes&nbsp;—&nbsp;Not&nbsp;Hours
          </span>
        </h1>
        <p className="mx-auto mt-2.5 max-w-2xl text-[15px] leading-relaxed text-brand-gray md:text-base" data-id="element-109" data-mp="2bdx3qlk27hm6">
          Stop planning every lesson from scratch. Get a complete, progressive Physical Education system with
          ready-to-use activities, inclusive adaptations, assessments, printable tools, and practical resources for
          Elementary and Secondary classes.
        </p>
        <img src={site.heroImage} alt={site.heroImageAlt} loading="eager" decoding="async" className="mx-auto my-3 h-auto w-full max-w-[440px] object-contain sm:my-4 sm:max-w-[500px]" data-id="element-110" data-mp="2z5c9ypeyij2p" />
        <div className="flex w-full max-w-sm flex-col items-center" data-id="element-111" data-mp="334uuvl6s2u5j">
          <CTAButton className="w-full" data-id="element-112" data-mp="1dq6k1odu5k9m">{CTA_LABEL}</CTAButton>
          <p className="mt-2.5 text-[11px] font-semibold leading-relaxed text-brand-gray sm:text-xs" data-id="element-113" data-mp="1dqew5e24wljr">
            Instant access <span className="px-1 text-brand-orange" data-id="element-114" data-mp="18tg36yu7ikn5">•</span> One-time payment{' '}
            <span className="px-1 text-brand-orange" data-id="element-115" data-mp="38v5tb07xlopf">•</span> Lifetime access
          </p>
          <p className="mt-1 text-[11px] text-brand-gray/80" data-id="element-116" data-mp="3dsxw4pa46v8e">Digital resources. Download and start planning immediately.</p>
        </div>
      </motion.div>
    </section>;
}